import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { cn } from '@/utils/cn-tw-merge';

interface SearchSectionTitleProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
}

export const SearchSectionTitle = ({ children, className, ...props }: SearchSectionTitleProps) => {
  return (
    <Typography
      variant={TypographyVariant.TITLE}
      className={cn('text-white whitespace-pre-line md:whitespace-normal mb-2', className)}
      {...props}
    >
      {children}
    </Typography>
  );
};
